import { useEffect, useState} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import api from '../../services/api'
import './filme-info.css'
import { toast} from 'react-toastify'



function Filme() {
    const {id} = useParams ()
    const navigate = useNavigate()


    const [filme, setFilme] = useState({})
    const [loading, setLoading] = useState (true)

    useEffect(() => {
        async function loadFilme(){
            await api.get(`/movie/${id}`, {
                params:{
                    api_key: "2c89f84a5cf34979dcf5918de3a5157c",
                    language: "pt-BR",
                }
            })
            .then((response) => {
                setFilme(response.data);
                setLoading(false)
            })
            .catch(() => {
                navigate("/", {replace:true})
                return
            })
        }

        loadFilme()

        return () => {
            console.log("componente desmontado");
        }

    }, [navigate, id])

    function salvarFilme() {
        const minhaLista = localStorage.getItem("@basicFlix")

        let filmesSalvos = JSON.parse(minhaLista) || [];

        const hasFilme = filmesSalvos.some( (filmesSalvo) => filmesSalvo.id === filme.id)

        if(hasFilme){
            toast.warn("Este filme já está na lista!")
            return
        }
        
        filmesSalvos.push(filme)
        localStorage.setItem("@basicFlix", JSON.stringify(filmesSalvos))
        toast.success("Filme salvo com Sucesso")
        }

    if(loading) {
        return (
            <div className='filme-info'>
                <h1>carregando detalhes...</h1>
            </div>
        )
    }
    return ( 
    <div className='filme-info'>
        <h1>{filme.title}</h1>
        <img src={`https://image.tmdb.org/t/p/original/${filme.backdrop_path}`} alt={filme.title}></img>
        <h3>Sinopse</h3>
        <span>{filme.overview}</span> <br/>
        <strong>Avaliação: {filme.vote_average}/10</strong>
        <strong>Duração: {filme.runtime} minutos</strong>


        <div className='area-buttons'>
            <button onClick={salvarFilme}>Salvar</button>
            <button>
                <a target="blank" rel="external" href={`https://youtube.com/results?search_query=${filme.title} Trailer`}>Trailer</a>
            </button>
        </div>
    
    
    </div>
    )
}

export default Filme